import React, { useEffect, useState } from "react";
import axios from "axios";
import './AdminContactList.css';
import { FaSearch, FaPlus, FaCheck, FaFileExport } from "react-icons/fa";

const AdminContactList = () => {
    const [contacts, setContacts] = useState([]);
    const [filteredContacts, setFilteredContacts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [contactsPerPage] = useState(5); // Adjust page size

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                const res = await axios.get("https://back.varankal.com/api/contact/all");
                setContacts(res.data);
                setFilteredContacts(res.data);
            } catch (error) {
                console.error("Error fetching contacts", error);
            }
        };

        fetchContacts();
    }, []);

    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const results = contacts.filter(contact =>
            contact.firstName.toLowerCase().includes(term) ||
            contact.lastName.toLowerCase().includes(term) ||
            contact.email.toLowerCase().includes(term) ||
            contact.subject.toLowerCase().includes(term)
        );
        setFilteredContacts(results);
        setCurrentPage(1); // reset to page 1 on search
    }, [searchTerm, contacts]);

    const indexOfLastContact = currentPage * contactsPerPage;
    const indexOfFirstContact = indexOfLastContact - contactsPerPage;
    const currentContacts = filteredContacts.slice(indexOfFirstContact, indexOfLastContact);

    const totalPages = Math.ceil(filteredContacts.length / contactsPerPage);

    const exportToCSV = () => {
        const headers = "First Name,Last Name,Email,Phone,Subject,Message,Date\n";
        const rows = filteredContacts.map(contact =>
            `${contact.firstName},${contact.lastName},${contact.email},${contact.phone},${contact.subject},"${contact.message.replace(/"/g, '""')}",${new Date(contact.createdAt).toLocaleString()}`
        ).join("\n");

        const blob = new Blob([headers + rows], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "contacts.csv";
        link.click();
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this contact?")) {
            try {
                await axios.delete(`https://back.varankal.com/api/contact/${id}`);
                const updatedContacts = contacts.filter(contact => contact._id !== id);
                setContacts(updatedContacts);
            } catch (error) {
                console.error("Delete error", error);
            }
        }
    };

    const handleVerify = async (id) => {
        try {
            const res = await axios.put(`https://back.varankal.com/api/contact/verify/${id}`);
            const updatedContact = res.data.contact;
            setContacts(contacts.map(contact => contact._id === id ? updatedContact : contact));
        } catch (error) {
            console.error("Error verifying contact:", error);
        }
    };


    return (
        <div className="admin-contact-container">
            <div className="header-section">
                <h2>Contact Submissions</h2>
                <div className="actions">
                    <div className="search-box">
                        <FaSearch className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search by name, email or subject..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <button className="export-btn" onClick={exportToCSV}>
                        <FaFileExport /> Export CSV
                    </button>
                </div>
            </div>

            <div className="table-container">
                <table className="admin-contact-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Subject</th>
                            <th>Message</th>
                            <th>Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentContacts.length > 0 ? (
                            currentContacts.map((contact, index) => (
                                <tr key={index}>
                                    <td>{indexOfFirstContact + index + 1}</td>
                                    <td>{contact.firstName} {contact.lastName}</td>
                                    <td>{contact.email}</td>
                                    <td>{contact.phone}</td>
                                    <td>{contact.subject}</td>
                                    <td>{contact.message}</td>
                                    <td>{new Date(contact.createdAt).toLocaleString()}</td>
                                    <td>
                                        {contact.verified ? (
                                            <FaCheck style={{ color: "green" }} />
                                        ) : (
                                            <button onClick={() => handleVerify(contact._id)}>
                                                Verify
                                            </button>
                                        )}
                                        <button
                                            className="delete-btn"
                                            onClick={() => handleDelete(contact._id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8">No contacts found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination">
                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i}
                                onClick={() => setCurrentPage(i + 1)}
                                className={currentPage === i + 1 ? 'active' : ''}
                            >
                                {i + 1}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminContactList;
